import { gql } from '@apollo/client';
import { DOCUMENT_FRAGMENT } from './documentFragment';

export const AGENCY_COVERAGE_FRAGMENT = gql`
  fragment AgencyCoverageFragment on AgencyCoverage {
    id
    carrier
    expirationDate
    document {
      ...DocumentFragment
    }
  }
  ${DOCUMENT_FRAGMENT}
`;
